<div class="header">
  <ng-content></ng-content>
  @if (!array.length) {
    <span class="none">Brak</span>
  }
  <!--  <div [ngStyle]="{ boxShadow: valueSubject | async }" class="example"></div>-->
  <lib-button (click)="addShadow()" icon-only>
    <mat-icon>add</mat-icon>
  </lib-button>
</div>
@for (shadow of array.controls; track shadow; let i = $index) {
  <div class="shadow">
    <lib-box-shadow-single-shadow
      [formControl]="shadow"
    ></lib-box-shadow-single-shadow>
    <lib-button (click)="array.removeAt(i)" icon-only>
      <mat-icon>delete</mat-icon>
    </lib-button>
  </div>
}
